import { render } from "./MyBillDetail.vue?vue&type=template&id=6ce372c2&scoped=true&ts=true"
import script from "./MyBillDetail.vue?vue&type=script&lang=ts"
export * from "./MyBillDetail.vue?vue&type=script&lang=ts"

import "./MyBillDetail.vue?vue&type=style&index=0&id=6ce372c2&scoped=true&lang=scss"

import exportComponent from "D:\\Project\\wallet\\wallet-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce372c2"]])

export default __exports__